import { Table } from "antd"
import { useEffect, useState } from "react"
import formatDate from "dateformat"
import { useQuery } from "react-query"
import { AxiosError } from "axios"
import Column from "antd/lib/table/Column"
import { IPendingScheduledPaymentViewModel } from "contexts/opus/context"
import useOpus from "contexts/opus/hooks/use-opus"
import { Link } from "react-router-dom"

export const PendingPayments: React.FunctionComponent = () => {
  const [pendingPayments, setPendingPayments] = useState<
    IPendingScheduledPaymentViewModel[] | []
  >([])
  const opus = useOpus()

  const { isFetching, refetch } = useQuery<
    IPendingScheduledPaymentViewModel[] | undefined,
    AxiosError
  >(
    ["pending-scheduled-payments"],
    async () => opus.reportsClient.getPendingScheduledPayments() || [],
    {
      onSuccess: (result) => {
        if (result) {
          setPendingPayments(result)
        }
      }
    }
  )

  useEffect(() => {
    if (isFetching === false && pendingPayments === null) {
      refetch()
    }
  })

  return (
    <>
      <Table
        scroll={{ x: "max-content" }}
        loading={isFetching}
        dataSource={pendingPayments}
        rowKey="policyId"
        pagination={{
          defaultPageSize: 10,
          hideOnSinglePage: true,
          position: ["bottomCenter"],
          size: "small"
        }}
      >
        <Column
          title="Policy Reference"
          dataIndex="policyReferenceID"
          key="policyReferenceID"
          render={(
            policyReferenceID,
            record: IPendingScheduledPaymentViewModel
          ) =>
            policyReferenceID && (
              <Link to={`/policy/${record.policyId}/summary`}>
                {policyReferenceID}
              </Link>
            )
          }
        />
        <Column title="Client Name" dataIndex="clientName" />
        <Column
          title="Cover Start Date"
          dataIndex="coverStartDate"
          render={(date: string) => formatDate(new Date(date), "dd/mm/yyyy")}
        />
        <Column
          title="Cover End Date"
          dataIndex="coverEndDate"
          render={(date: string) => formatDate(new Date(date), "dd/mm/yyyy")}
        />
        <Column
          title="Payment Date"
          dataIndex="paymentDate"
          render={(date: string) => formatDate(new Date(date), "dd/mm/yyyy")}
        />
      </Table>
    </>
  )
}
